import { z } from "zod";

export const mailDtoSchema = z.object({
  id: z.number(),
  mail: z.string(),
  valid: z.boolean(),
  default: z.boolean(),
});

export type TMailDto = z.infer<typeof mailDtoSchema>;
